module.exports = __webpack_public_path__ + "static/media/system-admin.e7c03494.svg";